import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Configure axios to always send credentials (cookies) with requests
axios.defaults.withCredentials = true;

// Suppress PostHog/third-party errors in development
if (typeof window !== 'undefined') {
  const originalError = console.error;
  console.error = (...args) => {
    if (args[0]?.includes?.('postMessage') || args[0]?.includes?.('PerformanceServerTiming')) {
      return;
    }
    originalError.apply(console, args);
  };
  
  window.addEventListener('error', (event) => {
    if (event.message?.includes?.('postMessage') || event.message?.includes?.('PerformanceServerTiming')) {
      event.preventDefault();
      return false;
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
